export type AppConfig = {
  apiPrefix: string;
  authenticatedEntryPath: string;
  unAuthenticatedEntryPath: string;
  tourPath: string;
  locale: string;
  enableMock: boolean;
}

const appConfig: AppConfig = {
  apiPrefix: '/api/v1',
  authenticatedEntryPath: '/home',
  unAuthenticatedEntryPath: '/',
  tourPath: '/',
  locale: 'en',
  enableMock: false,
}

export const API_CONFIG = {
  baseUrl: '/api/v1/sleep-apnea',
  timeout: 60000,
  endpoints: {
    assessment: {
      submit: '',
      submitGuest: '/guest',
      latest: '/latest',
      history: '/previous',
    },
  },
} as const;

export const THEME_CONFIG = {
  defaultMode: 'light' as const,
  colors: {
    light: {
      primary: '#147b72',
      background: '#ffffff',
      input: '#f9fafb',
      error: '#ff5c5c',
      text: '#717784',
      heading: '#101623',
      secondaryButton: '#e8f3f1',
      primaryButton: '#199a8e',
    },
    dark: {
      primary: '#199a8e',
      background: '#1a1a1a',
      input: '#2d2d2d',
      error: '#ff6b6b',
      text: '#e0e0e0',
      heading: '#ffffff',
      secondaryButton: '#3d3d3d',
      primaryButton: '#147b72',
    },
  },
} as const;

export const FORM_CONFIG = {
  validation: {
    email: {
      required: true,
      pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    },
    password: {
      required: true,
      minLength: 6,
    },
    name: {
      required: true,
      minLength: 2,
      maxLength: 50,
    },
  },
  assessment: {
    pages: 4,
    autoSave: true,
    autoSaveInterval: 30000,
  },
} as const;

export const UI_CONFIG = {
  animations: {
    duration: 300,
    easing: 'ease-in-out',
  },
  breakpoints: {
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    '2xl': 1536,
  },
  zIndex: {
    modal: 50,
    dropdown: 40,
    header: 30,
    overlay: 20,
  },
} as const;

export const STORAGE_CONFIG = {
  keys: {
    authToken: 'auth_token',
    userData: 'user_data',
    theme: 'theme_preference',
    formData: 'assessment_form_data',
  },
  expiration: {
    authToken: 7 * 24 * 60 * 60 * 1000,
    formData: 24 * 60 * 60 * 1000,
  },
} as const;

export const FEATURE_FLAGS = {
  enableSocialLogin: true,
  enableGuestAssessment: true,
  enableDarkMode: true,
  enableAnimations: true,
  enableAnalytics: false,
} as const;

export default appConfig;
